<template>
  <dialog-v2
    :title="title"
    :show="show"
    :loading="loading"
    @save="save"
    @close="$emit('close')">
    <template slot="content">
      <v-layout row wrap v-if="channel === 1">
        <v-flex xs12 class="text-opaque">
          <answer-template-switch v-model="form.enabled_in_call">
          </answer-template-switch>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md8 pr-5>
          <v-text-field
            v-model="form.name"
            v-validate="'required|max:100'"
            data-vv-name="name"
            data-vv-as="nombre"
            :error-messages="errors.collect('answerTemplate.name')"
            label="Nombre"
            color="black">
          </v-text-field>
        </v-flex>
        <v-flex md4>
          <v-menu offset-y class="w-100" max-height="250px">
            <v-text-field
              v-model="form.category"
              slot="activator"
              label="Categoria"
              item-text="category"
              item-value="category"
              v-validate="'required'"
              data-vv-name="category"
              data-vv-as="categoria"
              :error-messages="errors.collect('answerTemplate.category')"
              color="black">
            </v-text-field>
            <v-list v-if="categories.length > 0">
              <v-list-tile v-for="item in filteredCategories" :key="item.key" @click="form.category = item.category">
                <v-list-tile-title>{{ item.category }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
            <v-list v-else>

              <v-list-tile>
                <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-show="channel !== 1">
        <v-flex md12>
          <div id="textarea-wrapper">
            <textarea
              v-model="form.text"
              v-validate="`required|${form.channel === 2 ? 'max:160' : 'max:1000'}`"
              data-vv-name="text"
              data-vv-as="texto"
              placeholder="Texto"
              :class="{'has-error': errors.has('answerTemplate.text')}">
            </textarea>
          </div>
          <small 
          v-if="channel === 2"
            :class="{
              'd-block text-xs-right f1em mt-2': true,
              'grey--text': form.text.length <= 160,
              'error--text': form.text.length > 160
            }">
            {{ form.text.length }} / 160
          </small>
          <small class="error--text" v-if="errors.has('answerTemplate.text')">
            {{ errors.first('text') }}
          </small>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-show="channel === 1">
        <v-flex xs12>
          <vue-editor v-model="text" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="editorToolbar"></vue-editor>
          <small class="error--text" v-if="errors.has('answerTemplate.text')">
            {{ errors.first('answerTemplate.text') }}
          </small>
        </v-flex>
      </v-layout>
      <template v-if="channel === 1 && this.form.enabled_in_call">
        <v-layout my-3>
          <v-flex xs12 md8>
            <label>Archivos</label>
          </v-flex>
          <v-flex>
            <v-btn class="k-orange-linear white--text ma-0 bordered position-relative" block small>
              <v-icon class="mr-1" small>fa fa-plus</v-icon>
              Agregar archivo
              <input class="template-file" type="file" ref="template-file" @change="handleFiles" multiple>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <div class="text-center w-100 my-3" v-if="!files.length">
            <v-icon class="mr-2">fa fa-info-circle</v-icon> No hay archivos que mostrar.
          </div>
          <template v-else>
            <v-flex
              xs12
              class="d-flex align-center justify-between file-container px-3 py-1 mb-3"
              v-for="(file, index) in files" :key="`file-item-${index}`">
              <div>
                <v-icon class="k-orange-linear-text mr-2">fa fa-file</v-icon> {{ file.name }}
              </div>
              <div class="text-right">
                <v-btn class="k-orange-linear" small icon @click="removeFile(index)">
                  <v-icon small>fa fa-close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </template>
        </v-layout>
        <template v-if="oldFiles.length">
          <v-layout my-3>
            <v-flex xs12 md8>
              <label>Archivos cargados</label>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              xs12
              class="d-flex align-center justify-between file-container px-3 py-1 mb-3"
              v-for="(file, index) in oldFiles" :key="`answer-file-item-${index}`">
              <div>
                <v-icon class="k-orange-linear-text mr-2">fa fa-file</v-icon> {{ file.name }}
              </div>
              <div class="text-right">
                <v-btn class="k-orange-linear" small icon @click="deleteFile(file)">
                  <v-icon small>fa fa-close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </template>
      </template>
      <v-layout row wrap mt-2 justify-center align-center>
        <v-flex xs8>
          <v-switch
            id="automatic_reply
            "
            label="Respuesta automatica"
            v-model="form.automatic_reply"
            class="k-blue-linear-text">
          </v-switch>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            label="Orden"
            v-model="form.order"
            color="black"
            hint="Ordenamiento de mayor a menor"
            v-validate="`required`"
            data-vv-name="order"
            data-vv-as="orden"
            :error-messages="errors.collect('answerTemplate.order')"
            :persistent-hint="true">
          </v-text-field>
        </v-flex>
      </v-layout>
      <template v-if="form.automatic_reply">
        <v-layout row wrap :class="{'mb-5': form.answer_schedules.length}">
          <v-flex md3 pr-4>
            <v-select
              v-model="automaticReply.day"
              :items="weekDays"
              label="Dí­a"
              v-validate="`included:${weekDays.map(item => item.value).join(',')}`"
              data-vv-name="day"
              data-vv-as="dí­a"
              data-vv-scope="automaticReply"
              :error-messages="errors.collect('day', 'automaticReply')"
              color="grey"
              autocomplete>
            </v-select>
          </v-flex>
          <v-flex md3 offset-md1>
            <v-text-field
              v-model="automaticReply.startHour"
              label="Hora de inicio"
              ref="start_hour"
              prepend-icon="fas fa-clock fa-sm"
              type="time"
              v-validate="automaticReply.day !== null ? 'required|less_than:end_hour' : null"
              data-vv-name="start_hour"
              data-vv-scope="automaticReply"
              :error-messages="errors.collect('start_hour', 'automaticReply')"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex md3 offset-md1>
            <v-text-field
              v-model="automaticReply.endHour"
              ref="end_hour"
              label="Hora final"
              prepend-icon="fas fa-clock fa-sm"
              type="time"
              v-validate="automaticReply.day !== null ? 'required|bigger_than:start_hour' : null"
              data-vv-name="end_hour"
              data-vv-scope="automaticReply"
              :error-messages="errors.collect('end_hour', 'automaticReply')"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex md1 text-xs-right pt-2>
            <v-btn icon @click="saveAutomaticReply()">
              <v-icon small class="py-2">
                fas fa-check
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-for="(schedule, i) in form.answer_schedules" :key="`row-${i}`">
          <v-flex md3 pr-4>
            <small>Día</small>
            <p class="subheading">
              {{ weekDays.filter(item => item.value === schedule.day)[0].text }}
            </p>
          </v-flex>
          <v-flex md3 offset-md1>
            <small>Hora inicio</small>
            <p class="subheading">
              <v-icon class="mr-1">
                fas fa-clock
              </v-icon>
              {{ schedule.start_hour }}
            </p>
          </v-flex>
          <v-flex md3 offset-md1>
            <small>Hora fin</small>
            <p class="subheading">
              <v-icon class="mr-1">
                fas fa-clock
              </v-icon>
              {{ schedule.end_hour }}
            </p>
          </v-flex>
          <v-flex md1 text-xs-center>
            <v-btn icon @click="removeAutomaticReply(i)" class="ma-0 mb-3 mt-2">
              <v-icon small class="py-2">
                fas fa-times
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { VueEditor } from 'vue2-editor';
import DialogV2 from '@/components/global/DialogV2';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';
import AnswerTemplateSwitch from './AnswerTemplateSwitch';

export default {
  inject: ['$validator'],
  mixins: [
    emailEditorToolbarMixin,
  ],
  components: {
    DialogV2,
    VueEditor,
    AnswerTemplateSwitch,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: Number,
      default: 1,
    },
    answer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      text: '',
      form: {
        name: '',
        text: '',
        category: '',
        order: 0,
        automatic_reply: true,
        answer_schedules: [],
        enabled_in_call: false,
      },
      files: [],
      automaticReply: {
        day: '',
        startHour: '',
        endHour: '',
      },
      cancelToken: '',
      categories: [],
      loading: false,
    };
  },
  computed: {
    weekDays() {
      return [{
        value: null,
        text: 'Todos',
      }].concat(moment.weekdays().map((item, i) => ({
        value: i,
        text: _.upperFirst(item),
      })));
    },
    body() {
      let form = this.form;
      if (this.channel === 1) {
        form = {
          ..._.omit(this.form, ['text']),
          text: this.text,
        }
      }
      return {
        channel: this.channel,
        ..._.omit(form, 'answer_schedules'),
        // answer_schedules: JSON.parse(form.answer_schedules),
      };
    },
    title() {
      return 'Titulo';
    },
    filteredCategories() {
      if (this.form.category) {
        return this.categories.filter(item => item.category.toLowerCase().includes(this.form.category.toLowerCase()));
      }
      return this.categories;
    },
    isEdit() {
      return Object.keys(this.answer).length;
    },
    oldFiles() {
      if (!(this.answer.files || []).length) {
        return [];
      }
      return this.answer.files.map((item) => ({
        id: item.id,
        name: item.original_name,
      }));
    },
    method() {
      if (this.isEdit) {
        return 'patch';
      }
      return 'post';
    },
    url() {
      if (this.isEdit) {
        return `/answer_templates/${this.answer.id}`;
      }
      return '/answer_templates';
    },
  },
  methods: {
    getCategories() {
      this.cancelToken = this.axios.CancelToken.source();
      this.axios.get(`/answer_templates/categories?channel=${this.channel}`, {
        cancelToken: this.cancelToken.token,
      })
        .then((response) => {
          this.categories = [{
            category: 'Categorias',
            value: '',
          }].concat(response.data.map(item => ({
            category: _.upperFirst(item.category),
            value: item.category,
          })));
        }).catch(() => {});
    },
    saveAutomaticReply() {
      this.$validator.validateAll('automaticReply').then((validation) => {
        if (validation) {
          this.form.answer_schedules.push({
            day: this.automaticReply.day,
            start_hour: this.automaticReply.startHour,
            end_hour: this.automaticReply.endHour,
          });
          this.clearAutomaticReply();
          this.$validator.reset({
            scope: 'automaticReply',
          });
        }
      });
    },
    removeAutomaticReply(index) {
      this.form.answer_schedules.splice(index, 1);
    },
    clearInput() {
      const input = this.$refs['template-file'];
      if (input) {
        input.type = 'text';
        input.type = 'file';
      }
    },
    handleFiles($event) {
      this.files = Array.from($event.target.files);
      this.clearInput();
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    cleanForm() {
      this.form = {
        name: '',
        text: '',
        category: '',
        order: 0,
        enabled_in_call: false,
        automatic_reply: true,
        answer_schedules: [],
      };
      this.text = '';
      this.files = [];
      this.clearInput();
    },
    clearAutomaticReply() {
      Object.keys(this.automaticReply).forEach((key) => {
        this.automaticReply[key] = '';
      });
    },
    save() {
      this.$validator.validateAll('answerTemplate').then((result) => {
        console.log('result', result);
        if (result) {
          if (this.form.automatic_reply) {
            // Validate
          }
          this.loading = true;
          const formData = new FormData();
          const keys = Object.keys(this.body);
          for (let i = 0; i < keys.length; i += 1) {
            formData.append(keys[i], this.body[keys[i]]);
          }
          if (this.files.length) {
            this.files.forEach((file) => {
              formData.append('files[]', file);
            });
          }
          if (this.form.answer_schedules.length) {
            this.form.answer_schedules.forEach((item, index) => {
              formData.append(`answer_schedules[${index}][day]`, item.day);
              formData.append(`answer_schedules[${index}][start_hour]`, item.start_hour);
              formData.append(`answer_schedules[${index}][end_hour]`, item.end_hour);
            });
          }
          this.axios[this.method](this.url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }).then(() => {
            this.loading = false;
            this.$emit('saved');
            this.$emit('close');
          }).catch((error) => {
            this.loading = false;
            console.log('error', error);
          });
        }
      });
    },
    checkEdit() {
      if (this.isEdit) {
        this.form = {
          name: this.answer.name,
          category: this.answer.category,
          order: this.answer.order,
          enabled_in_call: !!this.answer.enabled_in_call,
          automatic_reply: !!this.answer.automatic_reply,
          answer_schedules: this.answer.answer_schedules,
        }
        if (this.channel === 1) {
          this.text = this.answer.text;
        } else {
          this.form.text =  this.answer.text;
        }
      }
    },
    deleteFile(file) {
      this.$emit('file-deleted', file);
      this.axios.delete(`/answer_templates/files/${file.id}`).catch(() => {
        this.$emit('file-delete-error', file);
      });
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.checkEdit();
        this.getCategories();
      } else {
        if (this.cancelToken) {
          this.cancelToken.cancel('Canceled by user');
        }
        this.cleanForm();
        this.clearAutomaticReply();
      }
    },
    'form.automatic_reply.length'() { // eslint-disable-line
      this.clearAutomaticReply();
    },
    form: {
      deep: true,
      handler() {
        this.$validator.reset();
      },
    },
  },
};

</script>
<style scoped>
.bordered {
  border-radius: 6px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.template-file {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
}
.file-container {
  border: 1px solid #eee;
}
.text-opaque {
  color: #707071;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center_v2/config/AnswerTemplateModal.vue